module.exports = __webpack_public_path__ + "img/profile-img.1677cc27.png";